import React, { useEffect, useState, useRef } from "react";
import { postRequest } from "utils/request";
import { CircularProgress } from "@material-ui/core";
import "./style.css";

import { i18n } from "../../translate/i18n";
import { useModal } from "hooks/modal";
import format from "utils/dateFormat";

function Chat({ FullTicket, colors }) {
  const [customer, setCustomer] = useState({});
  const [company, setCompany] = useState({});
  const [ticket, setTicket] = useState([]);
  console.log("ticket", ticket);
  const [input, setInput] = useState("");
  const [enablesend, setEnableSend] = useState(true);

  const { togglePhotoModal } = useModal();

  const divScroll = useRef(null);

  useEffect(() => {
    divScroll?.current?.scrollIntoView();
  }, [ticket]);

  useEffect(() => {
    setCustomer(FullTicket.Customer);
    setTicket(FullTicket.TicketHistories);

    let newcompany = {
      name: FullTicket.Company.nickName,
      photo: FullTicket.Company.pathLogo,
      updatedat: FullTicket.updatedAt,
      typeticket: FullTicket.ticketTypeDescription,
      ticket: FullTicket.ticket,
      ticketstatus: FullTicket.CompanyStatus.statusUser,
    };

    setCompany(newcompany);
  }, [FullTicket]);

  const SendMessage = async (e) => {
    e.preventDefault();

    if (input !== "") {
      setEnableSend(false);

      //ENVIA MENSAGEM
      const ReturnPost = await postRequest(`/chat/message`, {
        TicketId: FullTicket.id,
        message: input,
      });
      if (ReturnPost.success) {
        setInput("");
        setEnableSend(true);
        setTicket(ReturnPost.data.TicketHistories);
      }
    }
  };

  const handleUpload = (file) => {
    setEnableSend(false);
    const formData = new FormData();
    formData.append("TicketId", FullTicket.id);
    formData.append("file", file.target.files[0]);
    postRequest("/chat/file", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((resp) => {
      if (resp.data) {
        setTicket(resp.data.TicketHistories);
      }
      setEnableSend(true);
    });
  };

  return (
    <div className="container-chat-component">
      <div className="area-list-chat-component">
        <ul
          className="conversation-list"
          data-simplebar="init"
          style={{
            display: "flex",
            height: "100%",
            width: "100%",
            marginBottom: 0,
          }}
        >
          <div className="simplebar-wrapper" style={{ margin: 0 - 15 }}>
            <div className="simplebar-mask">
              <div className="simplebar-offset" style={{ right: 0, bottom: 0 }}>
                <div
                  className="simplebar-content-wrapper"
                  id="div-chat"
                  style={{
                    height: "auto",
                    overflow: "auto",
                    overflowY: "scroll",
                  }}
                >
                  {ticket ? (
                    <div
                      className="simplebar-content"
                      key={ticket}
                      //corrigir  0 15
                    >
                      {ticket.map((data) => (
                        <div
                          style={{ display: !data.visible && "none" }}
                          key={data.id}
                        >
                          <li
                            className={
                              data.senderUser ? "clearfix odd" : "clearfix"
                            }
                          >
                            <div
                              onClick={() =>
                                togglePhotoModal(
                                  data.senderUser
                                    ? customer.photo
                                    : company.photo
                                )
                              }
                              className="chat-avatar"
                            >
                              <img
                                src={
                                  data.senderUser
                                    ? customer.photo
                                    : company.photo
                                }
                                className="rounded"
                                alt="avatar-company"
                              />
                              <i>{format(data.updatedAt, "HH:mm")}</i>
                            </div>
                            <div
                              className="conversation-text"
                              style={{ width: "95% !important" }}
                            >
                              {data.typeFileId === 1 ? (
                                <div
                                  className="chat-messages"
                                  style={{
                                    backgroundColor: data.senderUser
                                      ? colors.backgroundColorUserAnswer
                                      : colors.backgroundColorCompanyAnswer,
                                    borderLeftColor: "black",
                                  }}
                                >
                                  <div>
                                    {data.message
                                      .split("\n")
                                      .map((sentence) => (
                                        <p
                                          key={sentence}
                                          className="mt-0 pt-0 pb-0"
                                          style={{
                                            marginBottom: 1,
                                            display: "flex",
                                            justifyContent: "start",
                                          }}
                                        >
                                          {sentence
                                            .split("\t")
                                            .map((tabulation) => (
                                              <span
                                                key={tabulation}
                                                style={{
                                                  minWidth:
                                                    sentence.split("\t")
                                                      .length > 1
                                                      ? "150px"
                                                      : undefined,
                                                  fontSize: "12px",
                                                  lineHeight: "18px",
                                                }}
                                              >
                                                {tabulation}
                                              </span>
                                            ))}
                                        </p>
                                      ))}
                                  </div>
                                </div>
                              ) : (
                                <>
                                  {data.typeFileId === 2 ? (
                                    <div
                                      style={{
                                        cursor: "pointer",
                                        width: "95%; !important",
                                      }}
                                    >
                                      <div className="card mb-1 shadow-none border text-left">
                                        <div className="p-2">
                                          <div className="row align-items-center">
                                            <div className="col-auto">
                                              <div className="avatar-sm">
                                                <span
                                                  style={{ fontSize: 12 }}
                                                  className="avatar-title rounded"
                                                >
                                                  {i18n.t("archive")}
                                                </span>
                                              </div>
                                            </div>
                                            <div className="col pl-0">
                                              <span
                                                style={{ fontSize: 12 }}
                                                className="text-muted font-weight-bold"
                                              >
                                                {data.nameFile}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      {data.typeFileId === 3 ? (
                                        <div className="p-0">
                                          <img
                                            alt=""
                                            className="img-chat-company-talk"
                                            src={data.pathFile}
                                            onClick={() =>
                                              togglePhotoModal(data.pathFile)
                                            }
                                          />
                                        </div>
                                      ) : (
                                        <>
                                          {data.typeFileId === 4 ? (
                                            <div className="p-0">
                                              <video
                                                controls
                                                style={{ minHeight: 250 }}
                                                controlsList="nodownload"
                                                className="img-chat-company-talk"
                                                src={data.pathFile}
                                              />
                                            </div>
                                          ) : (
                                            <div className="p-0">
                                              <audio
                                                controls
                                                style={{ minHeight: 60 }}
                                                controlsList="nodownload"
                                                src={data.pathFile}
                                              />
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          </li>
                          <div ref={divScroll} />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
      <div className="area-input-chat-component">
        <form className="area-input-chat-component" onSubmit={SendMessage}>
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            disabled={Number(company.ticketstatus) === 4}
          />
          <div className="area-buttons-chat-component">
            <div
              className="btn-group-client-chat"
              style={{
                height: "100%",
                width: "80%",
              }}
            >
              {enablesend ? (
                <>
                  <button
                    disabled={Number(company.ticketstatus) === 4}
                    className="btn btn-light"
                    style={{
                      backgroundColor: "#ddd",
                      border: "1px",
                      padding: 0,
                    }}
                  >
                    <label
                      htmlFor="file-input"
                      className="uil uil-paperclip"
                      style={{
                        display: "flex",
                        width: "100%",
                        height: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        padding: 14,
                      }}
                    ></label>
                    <input
                      id="file-input"
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleUpload}
                      disabled={Number(company.ticketstatus) === 4}
                    />
                  </button>

                  <button
                    type="submit"
                    className="btn btn-success"
                    style={{ marginLeft: 0 }}
                    disabled={Number(company.ticketstatus) === 4}
                  >
                    <i className="uil uil-message"></i>
                  </button>
                </>
              ) : (
                <CircularProgress
                  className="loading-send-chat-client-page"
                  size={20}
                />
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Chat;
